import React, {useState} from "react";

const CustomSelect = ({ariaLabel, className = "", name, onBlur, onChange, options, value}) => {
    const [open, setOpen] = useState(false);
    const selectedOption = options.find((option) => String(option.value) === String(value)) || options[0];

    const handleSelect = (option) => {
        if (option.disabled) {
            return;
        }

        setOpen(false);

        if (onChange) {
            onChange({
                target: {
                    name,
                    value: String(option.value),
                },
            });
        }
    };

    const handleBlur = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setOpen(false);

            if (onBlur) {
                onBlur({
                    target: {
                        name,
                        value,
                    },
                });
            }
        }
    };

    return (
        <div className={`custom-select-control ${className}`} onBlur={handleBlur}>
            <button
                type="button"
                className="custom-select-toggle"
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-label={ariaLabel}
                onClick={() => setOpen(!open)}
            >
                <span>{selectedOption.label}</span>
            </button>
            {open &&
            <div className="custom-select-menu" role="listbox">
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        role="option"
                        disabled={option.disabled}
                        aria-selected={String(option.value) === String(value)}
                        className={"custom-select-option " + (String(option.value) === String(value) ? "selected " : "") + (option.disabled ? "disabled" : "")}
                        onClick={() => handleSelect(option)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            }
        </div>
    );
};

export default CustomSelect;
